import React from "react";

const About = () => {
  // 1. Put your content in an array for easy management
  const features = [
    {
      title: "⚙ Engineering & Design",
      desc: "Students design, build, and iterate a competition robot from scratch each season — learning mechanical engineering, CAD concepts, and hands-on fabrication.",
    },
    {
      title: "💻 Programming",
      desc: "We code autonomous robot behavior and driver-control systems using Java. Members develop real software engineering skills used in professional development.",
    },
    {
      title: "📋 Business & Marketing",
      desc: "Every team manages a brand, pitches to sponsors, writes a business plan, and markets itself — building skills in communication and finance.",
    },
    {
      title: "🌟 Community Outreach",
      desc: "FTC teams earn awards for giving back. We run STEM events, mentor younger students, and connect with our community.",
    },
    {
      title: "🏆 Competition",
      desc: "Each season a new game challenge is released. Teams compete in qualifying tournaments, state championships, and the World Championship.",
    },
    {
      title: "🎓 Scholarships",
      desc: "FIRST alumni have access to tens of millions of dollars in scholarships. 61% of alumni major in engineering or computer science.",
    },
  ];

  return (
    <section id="about">
      <div className="section-inner">
        <div className="section-eyebrow">What We Do</div>
        <div className="section-title">
          More than a robotics team.
          <br />
          <span style={{ color: "var(--gold)" }}>
            We are FIRST Tech Challenge.
          </span>
        </div>
        <div className="section-divider"></div>

        <p
          style={{
            color: "var(--muted)",
            fontSize: "16px",
            maxWidth: "720px",
            lineHeight: "1.8",
            marginBottom: "3rem",
          }}
        >
          FIRST Tech Challenge is a student-led program that goes far beyond
          building robots. We are engineers, programmers, designers, marketers,
          fundraisers, and community leaders — all on the same team. FTC
          develops the skills that colleges and employers actually look for,
          wrapped in one of the most competitive student programs in the world.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "1.25rem",
          }}
        >
          {/* 2. Map through the array to generate the cards */}
          {features.map((item, index) => (
            <div className="about-card" key={index}>
              <div className="about-card-title">{item.title}</div>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
